/* ─────────────────────────────────────────────────────────────────────────
   LES MONTÉES DU PANIER — abonnement et format, depuis le tiroir ou /cart.

   ⚠️ SHOPIFY NE SAIT PAS CHANGER LA VARIANTE D'UNE LIGNE. `/cart/change.js`
   change la quantité et le forfait, jamais l'article. Une montée de format
   est donc un AJOUT suivi d'un RETRAIT — dans cet ordre, jamais l'inverse :
   si l'ajout échoue (rupture), le client garde sa ligne d'origine. Retirer
   d'abord, c'est risquer de vider le panier sur une erreur réseau.

   ⚠️ ON RETIRE PAR CLÉ DE LIGNE, PAS PAR INDEX. L'ajout peut réordonner le
   panier ; `item.key` est stable, le numéro de ligne ne l'est pas.

   ⚠️ LE TIROIR ET LA PAGE NE SE REPEIGNENT PAS PAREIL. Le tiroir a
   `renderContents` (Dawn) ; la page remplace `.js-contents` dans deux
   sections dont l'identifiant est porté par le DOM. On demande à Shopify
   les sections du contexte où le bouton a été cliqué, pas les deux.
   ───────────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  const URL_CHANGE = (window.routes && routes.cart_change_url) || '/cart/change';
  const URL_AJOUT = (window.routes && routes.cart_add_url) || '/cart/add';

  function poste(url, corps) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status >= 400) throw new Error(j.description || j.message || 'panier');
        return j;
      });
    });
  }

  /* Où sommes-nous, et comment repeindre ce qui a changé.
     `forcerTiroir` sert à l'ajout depuis la fiche produit : le bouton n'est
     pas DANS le tiroir, mais c'est le tiroir qu'il doit ouvrir. */
  function contexte(bouton, forcerTiroir) {
    if (forcerTiroir || bouton.closest('cart-drawer')) {
      return {
        sections: ['cart-drawer', 'cart-icon-bubble'],
        peindre: function (etat) {
          const tiroir = document.querySelector('cart-drawer');
          if (!tiroir || !etat.sections) return;
          /* ⚠️ LA CLASSE `is-empty` SE BASCULE AVANT LE RENDU. Dawn la lit
             dans `open()` pour choisir où piéger le focus : si elle reste
             posée alors que le panier n'est plus vide, il cherche
             `.drawer__inner-empty`, qui vient justement de disparaître, et
             lève « Cannot read properties of null ». Le tiroir s'ouvre quand
             même, mais le piège à focus ne se pose pas — donc le clavier
             s'échappe du tiroir, et une erreur traîne à la console.
             Mesuré en production le 29/09 après le premier ajout. */
          const vide = typeof etat.item_count === 'number' ? etat.item_count === 0 : false;
          tiroir.classList.toggle('is-empty', vide);
          tiroir.renderContents(etat);
        },
      };
    }

    const cibles = [];
    const articles = document.getElementById('main-cart-items');
    const pied = document.getElementById('main-cart-footer');
    if (articles) cibles.push({ hote: 'main-cart-items', section: articles.dataset.id, dans: '.js-contents' });
    if (pied) cibles.push({ hote: 'main-cart-footer', section: pied.dataset.id, dans: '.js-contents' });
    cibles.push({ hote: 'cart-icon-bubble', section: 'cart-icon-bubble', dans: '.shopify-section' });

    return {
      sections: cibles.map(function (c) { return c.section; }).filter(Boolean),
      peindre: function (etat) {
        if (!etat.sections) return;
        cibles.forEach(function (c) {
          const hote = document.getElementById(c.hote);
          const brut = etat.sections[c.section];
          if (!hote || !brut) return;
          const arbre = new DOMParser().parseFromString(brut, 'text/html');
          const source = arbre.querySelector(c.dans);
          if (!source) return;
          (hote.querySelector(c.dans) || hote).innerHTML = source.innerHTML;
        });
        const vide = etat.item_count === 0;
        if (articles) articles.classList.toggle('is-empty', vide);
        if (pied) pied.classList.toggle('is-empty', vide);
      },
    };
  }

  function occupe(bouton, oui) {
    if (bouton.dataset.tkMonte === 'plan') {
      bouton.closest('.tk-plans').querySelectorAll('.tk-plan').forEach(function (b) { b.disabled = oui; });
    }
    bouton.disabled = oui;
    bouton.setAttribute('aria-busy', oui ? 'true' : 'false');
    const roue = bouton.querySelector('.loading__spinner');
    const texte = bouton.querySelector('.tk-monte__btn-t');
    if (roue) roue.classList.toggle('hidden', !oui);
    if (texte) texte.classList.toggle('tk-monte__btn-t--tu', oui);
  }

  function crie(bouton, message) {
    const zone =
      bouton.closest('cart-drawer')
        ? document.getElementById('CartDrawer-CartErrors')
        : document.getElementById('cart-errors');
    if (zone) zone.textContent = message;
  }

  function monter(bouton) {
    const ctx = contexte(bouton);
    const cle = bouton.dataset.cle;
    const qte = Number(bouton.dataset.qte) || 1;
    const plan = bouton.dataset.plan ? Number(bouton.dataset.plan) : null;
    const variante = bouton.dataset.variante ? Number(bouton.dataset.variante) : null;
    const commun = { sections: ctx.sections, sections_url: window.location.pathname };

    occupe(bouton, true);
    crie(bouton, '');

    let promesse;
    const genre = bouton.dataset.tkMonte;

    if (genre === 'plan') {
      /* Le choix de rythme sous la ligne : on change le FORFAIT de la ligne, la quantité ne bouge pas.
         `selling_plan: null` retire le forfait (vérifié en production le 01/10). */
      if (bouton.getAttribute('aria-checked') === 'true') { occupe(bouton, false); return Promise.resolve(); }
      promesse = poste(URL_CHANGE, Object.assign({ id: cle, quantity: qte, selling_plan: plan }, commun));
    } else if (genre === 'deux') {
      /* « À deux » : la même ligne, un exemplaire de plus ; la remise automatique fait le reste. */
      promesse = poste(URL_CHANGE, Object.assign({ id: cle, quantity: qte }, commun));
    } else if (!variante) {
      /* A — l'article ne bouge pas, seul son forfait change.

         ⚠️ PLUSIEURS LIGNES, PAS UNE. Mesuré le 29/09 : la carte ne portait
         que la PREMIÈRE ligne du panier. Sur un panier de 173,30 € réparti en
         deux lignes, elle proposait l'abonnement sur 29,90 € et laissait les
         143,40 € restants à l'unité. Le client cliquait « activer
         l'abonnement » et repartait avec un panier à moitié abonné.
         `data-lignes` porte désormais « clé|quantité|plan; » pour CHAQUE
         ligne non abonnée. On les convertit en série — `/cart/change.js` ne
         prend qu'une ligne à la fois — et on ne repeint qu'à la fin. */
      const lignes = (bouton.dataset.lignes || '').split(';').filter(Boolean).map(function (x) {
        const p = x.split('|');
        return { cle: p[0], qte: Number(p[1]) || 1, plan: Number(p[2]) || null };
      });
      if (!lignes.length) { occupe(bouton, false); return Promise.resolve(); }
      promesse = lignes.reduce(function (chaine, l, i) {
        return chaine.then(function () {
          const dernier = i === lignes.length - 1;
          const corps = { id: l.cle, quantity: l.qte, selling_plan: l.plan };
          return poste(URL_CHANGE, dernier ? Object.assign(corps, commun) : corps);
        });
      }, Promise.resolve());
    } else {
      /* B — on ajoute le format visé, PUIS on retire l'ancien. */
      const article = { id: variante, quantity: qte };
      if (plan) article.selling_plan = plan;
      promesse = poste(URL_AJOUT, { items: [article] }).then(function () {
        return poste(URL_CHANGE, Object.assign({ id: cle, quantity: 0 }, commun));
      });
    }

    return promesse
      .then(function (etat) {
        ctx.peindre(etat);
        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tropik-monte', cartData: etat });
        }
      })
      .catch(function (e) {
        occupe(bouton, false);
        crie(bouton, (window.cartStrings && cartStrings.error) || 'Le panier n’a pas pu être mis à jour.');
        console.warn('[tropik] montée refusée :', e.message);
      });
  }

  /* ─────────────────────────────────────────────────────────────────────
     L'AJOUT AU PANIER OUVRE LE TIROIR, IL NE QUITTE PAS LA PAGE.

     ⚠️ Mesuré en production le 29/09, au téléphone : cliquer « Je commence »
     envoyait sur `/cart`. Le formulaire de la buybox est un `<form>` natif
     qui poste vers `/cart/add` ; Shopify répond par une redirection vers le
     panier. Le client quittait donc la fiche produit — et ne voyait JAMAIS
     le tiroir, donc jamais les deux montées. Tout le levier d'abonnement et
     de format était contourné sur le chemin principal.

     ⚠️ ON INTERCEPTE, ON NE REMPLACE PAS. Sans JavaScript, le `<form>` part
     comme avant et le client atterrit sur `/cart`, qui fonctionne et porte
     les mêmes montées (règle 16 : rien d'essentiel ne dépend du JavaScript).
     ───────────────────────────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    const f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    /* ⚠️ ON INTERCEPTE TOUT CE QUI POSTE VERS `/cart/add`, PAS UN ID PRÉCIS.
       La première version ne connaissait que `buybox-form`. Le 29/09, en
       ajoutant la vitrine du panier vide — un second formulaire d'ajout — le
       clic est reparti sur `/cart`, exactement la panne qu'on venait de
       réparer sur la fiche produit. Une garde nominative ne protège que ce
       qu'on a pensé à nommer ; elle rate par construction tout ce qu'on
       ajoutera ensuite, et elle rate en SILENCE.
       Le bon critère n'est pas l'identité du formulaire, c'est sa
       DESTINATION. */
    const cible = f.getAttribute('action') || '';
    if (cible.indexOf('/cart/add') === -1) return;
    /* Boutique réglée sur « page panier » plutôt que « tiroir » : le
       formulaire natif fait déjà exactement ce qu'il faut. */
    if (!document.querySelector('cart-drawer')) return;
    e.preventDefault();

    const bouton = f.querySelector('[type=submit]');
    const ctx = contexte(f, !!document.querySelector('cart-drawer'));
    const donnees = new FormData(f);
    donnees.append('sections', ctx.sections.join(','));
    donnees.append('sections_url', window.location.pathname);

    if (bouton) { bouton.disabled = true; bouton.setAttribute('aria-busy', 'true'); }

    fetch(URL_AJOUT + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: donnees })
      .then(function (r) { return r.json(); })
      .then(function (etat) {
        if (etat.status && etat.status >= 400) throw new Error(etat.description || 'ajout');
        ctx.peindre(etat);
        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tropik-buybox', cartData: etat });
        }
      })
      .catch(function (err) {
        /* On ne laisse pas le client sans panier : on repart sur la route
           native, qui aboutit à `/cart`. Moins bien, mais jamais rien. */
        console.warn('[tropik] ajax refusé, on poste en clair :', err.message);
        f.submit();
      })
      .finally(function () {
        if (bouton) { bouton.disabled = false; bouton.setAttribute('aria-busy', 'false'); }
      });
  });

  /* Délégué sur le document : le tiroir se repeint entièrement à chaque
     changement, donc un écouteur posé sur les boutons mourrait au premier
     rendu (règle apprise sur la pop-up). */
  document.addEventListener('click', function (e) {
    const bouton = e.target.closest('[data-tk-monte]');
    if (!bouton || bouton.disabled) return;
    e.preventDefault();
    monter(bouton);
  });
})();
